<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md6 sm8>
          <h3 class="text-center">Edit Insurance Provider</h3>
          <v-card>
            <v-card-text>
              <form @submit.stop.prevent="saveProvider(provider)">
                <v-text-field label="Insurance's Name" v-model="provider.name" required="required" :rules="[form_rules.required]" min="3"></v-text-field>
                <v-text-field label="Address" v-model="provider.address" min="3"></v-text-field>
                <v-text-field label="Phone Number" v-model="provider.phone" placeholder="+254777777777"></v-text-field>
                <v-text-field label="Email Address" v-model="provider.email" type="email" placeholder="Enter email address"></v-text-field>
                <v-text-field label="Link" type="url" v-model="provider.link" placeholder="https://......."></v-text-field>
                <v-btn type="submit" small class="pull-right">Next</v-btn><br>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'AddInsuranceProvider',
    layout,
    props: [
      'insurance_provider'
    ],
    components: {},
    metaInfo () {
      return {
        title: 'Add Insurance Providers',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        provider: this.$inertia.form({
          name: this.insurance_provider.name,
          address: this.insurance_provider.address,
          phone: this.insurance_provider.phone,
          email: this.insurance_provider.email,
          link: this.insurance_provider.link,
          id: this.insurance_provider.id,
        }, {
          bag: 'updateInsuranceProvider'
        })
      }
    },
    methods: {
      saveProvider (provider) {
        this.provider.put('/insurance-providers/' + provider.id)
      },
    },
  }
</script>

<style>
   /**/
</style>
